export default __webpack_public_path__ + "static/media/img-0452-luxembourg-premium-face.c649d491.png";